import config from '../../../utils/config';

function Receipts() {
  return (
    <div id="main-container" className="main-container nav-effect-1">
      <iframe
        style={{ top: '0px' }}
        id="ouilink-iframe"
        src={`${config.reportingV4Url}receipts`}
      />
    </div>
  );
}
export default Receipts;